import { motion } from "framer-motion";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { useState } from "react";
import { SignupModal } from "@/components/landing/SignupModal";

const ProcesamientoDatos = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header onOpenModal={() => setIsModalOpen(true)} />
      
      <main className="pt-32 pb-24 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block text-[#E05D3A] text-sm font-semibold tracking-widest uppercase mb-4">
              Legal
            </span>
            <h1 className="font-outfit text-4xl sm:text-5xl font-light tracking-tight mb-4">
              Acuerdo de Procesamiento de Datos (DPA)
            </h1>
            <p className="text-zinc-500 mb-12">Última actualización: Diciembre 2024</p>

            <div className="prose prose-invert prose-lg max-w-none space-y-8">
              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">1. Definiciones y Roles</h2>
                <div className="text-zinc-400 leading-relaxed space-y-4">
                  <p><strong className="text-white">Controlador de datos:</strong> El coach/nutricionista que utiliza Antropia.</p>
                  <p><strong className="text-white">Procesador de datos:</strong> Antropia.</p>
                  <p><strong className="text-white">Sujeto de datos:</strong> El cliente del coach.</p>
                </div>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">2. Categorías de Datos Procesados</h2>
                <ul className="text-zinc-400 list-disc pl-6 space-y-2">
                  <li><strong className="text-white">Datos personales básicos:</strong> Nombre, edad, sexo</li>
                  <li><strong className="text-white">Datos biométricos/de salud:</strong> Mediciones, peso, porcentaje de grasa, fotos</li>
                  <li><strong className="text-white">Datos de consulta:</strong> Audio, transcripciones, resúmenes de IA, notas del coach</li>
                </ul>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">3. Finalidad del Procesamiento</h2>
                <ul className="text-zinc-400 list-disc pl-6 space-y-2">
                  <li>Almacenamiento seguro de datos</li>
                  <li>Procesamiento de IA (transcripción, resúmenes)</li>
                  <li>Cálculos de composición corporal</li>
                  <li>Visualización de datos</li>
                  <li>Vista de progreso del cliente</li>
                  <li>Generación de informes</li>
                </ul>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">4. Sub-procesadores Autorizados</h2>
                <div className="overflow-x-auto">
                  <table className="w-full text-zinc-400 text-sm">
                    <thead>
                      <tr className="border-b border-white/10">
                        <th className="text-left py-3 text-white">Proveedor</th>
                        <th className="text-left py-3 text-white">Servicio</th>
                        <th className="text-left py-3 text-white">Datos Procesados</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b border-white/5">
                        <td className="py-3">Google Cloud</td>
                        <td className="py-3">IA (Gemini)</td>
                        <td className="py-3">Audio, texto para transcripción</td>
                      </tr>
                      <tr className="border-b border-white/5">
                        <td className="py-3">Cloudflare R2</td>
                        <td className="py-3">Almacenamiento</td>
                        <td className="py-3">Archivos, imágenes, audio</td>
                      </tr>
                      <tr className="border-b border-white/5">
                        <td className="py-3">MongoDB Atlas</td>
                        <td className="py-3">Base de datos</td>
                        <td className="py-3">Todos los datos estructurados</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p className="text-zinc-500 text-sm mt-4">
                  El controlador autoriza el uso de estos sub-procesadores. Se notificará cualquier 
                  incorporación de nuevos sub-procesadores.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">5. Medidas de Seguridad Técnicas y Organizativas</h2>
                <div className="text-zinc-400 leading-relaxed space-y-4">
                  <p><strong className="text-white">Encriptación:</strong> TLS 1.3 en tránsito, AES-256 en reposo</p>
                  <p><strong className="text-white">Aislamiento:</strong> Multi-tenant con almacenamiento segmentado</p>
                  <p><strong className="text-white">Control de acceso:</strong> JWT, RBAC, principio de mínimo privilegio</p>
                  <p><strong className="text-white">Monitoreo:</strong> Logs de auditoría, alertas de seguridad</p>
                  <p><strong className="text-white">Copias de seguridad:</strong> Encriptadas, diarias, retención de 30 días</p>
                </div>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">6. Derechos del Controlador</h2>
                <ul className="text-zinc-400 list-disc pl-6 space-y-2">
                  <li>Solicitar exportación completa de datos</li>
                  <li>Solicitar eliminación total</li>
                  <li>Acceder a auditorías de acceso</li>
                  <li>Restringir procesamiento de IA</li>
                </ul>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">7. Asistencia con Derechos de los Sujetos</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Antropia proporciona herramientas y asiste al controlador para responder a las 
                  solicitudes de derechos de los clientes (acceso, rectificación, eliminación, etc.).
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">8. Notificación de Brechas de Seguridad</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Antropia notificará al controlador dentro de 72 horas del descubrimiento de una 
                  brecha de seguridad, incluyendo: naturaleza de la brecha, datos afectados y 
                  medidas tomadas.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">9. Duración y Terminación</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Este DPA es válido mientras se utilice el servicio. Los datos se eliminan después 
                  de la terminación. El controlador puede solicitar certificado de eliminación.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">10. Transferencias Internacionales</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Si los datos se procesan internacionalmente, se implementarán garantías apropiadas 
                  (como Cláusulas Contractuales Estándar).
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">Contacto DPA</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Para consultas sobre procesamiento de datos: <a href="mailto:dpa@antropia.app" className="text-[#E05D3A] hover:underline">dpa@antropia.app</a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
      <SignupModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default ProcesamientoDatos;
